exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".connection-problem-dialog{color:#1a242e;font-family:'Montserrat', sans-serif}.connection-problem-dialog__paper{align-items:center;justify-content:center}.connection-problem-dialog__wrap{max-width:300px}@media (min-width: 481px){.connection-problem-dialog__wrap{max-width:420px}}@media (min-width: 769px){.connection-problem-dialog__wrap{max-width:600px}}.connection-problem-dialog__top{align-items:center;display:flex;margin-bottom:5rem}.connection-problem-dialog__icon{margin-right:20px}.connection-problem-dialog__title.title{color:inherit;font-family:inherit;font-weight:bold;font-size:2.75rem}.connection-problem-dialog__description{font-size:2rem;line-height:3.25rem}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/ConnectionProblemModal/style.scss
// module id = 1750
// module chunks = 0